export default "__VITE_ASSET__BOwwujPu__"